import { useQuery } from "@tanstack/react-query";

import { apiClient } from "../services/api";
import { VirtualTerminal } from "../services/queries/virtual-terminals/types";
import { ApiRoutes } from "../constants";
import { logError } from "../utils/sentry";
import { arrayOrEmpty } from "../utils";

export const useGetVirtualTerminals = (businessId: string) => {
  const fetchVirtualTerminals = async () => {
    try {
      const { data } = await apiClient.get({
        url: `${ApiRoutes.VIRTUAL_TERMINAL}?pageNumber=1&pageSize=10&orderBy=createdAt&order=desc`,
      });
      return arrayOrEmpty<VirtualTerminal>(data?.list);
    } catch (err) {
      logError(err);
      throw err;
    }
  };

  const { data, isLoading, isSuccess, error, isError, refetch, isFetching } =
    useQuery<VirtualTerminal[], Error>({
      queryKey: ["virtualTerminals"],
      queryFn: fetchVirtualTerminals,
      initialData: [],
      enabled: !!businessId,
    });

  return { data, isLoading, isSuccess, error, isError, refetch, isFetching };
};
